
import { useContext } from 'react';

import isNil from 'lodash/isNil';

import { FormContext } from './FormContext';

function useFormContext() {
  const ctx = useContext(FormContext);
  if (import.meta.env.MODE === 'development') {
    if (isNil(ctx)) {
      throw new Error(
        `
          Context "FormContext" is not defined above components tree.
          It can happens when you use Field components outside Form component.
          If you need to use Field components outside form use FieldBase components.
          `,
      );

    }
  }
  return ctx;
}

export default useFormContext;
